import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OBTAirportDetails } from '@sabstravtech/obtservices/base';
import { faRightLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-swap-button',
  templateUrl: './swap-button.component.html',
  styleUrl: './swap-button.component.scss',
  standalone: false
})
export class SwapButtonComponent {
  @Input() departLocation: string | OBTAirportDetails;
  @Input() arriveLocation: string | OBTAirportDetails;
  @Output() locationsSwapped = new EventEmitter<{
    depart: string | OBTAirportDetails;
    arrive: string | OBTAirportDetails;
  }>();

  faRightLeft = faRightLeft;

  onSwap() {
    this.locationsSwapped.emit({ depart: this.arriveLocation, arrive: this.departLocation });
  }
}
